import React from "react";

const NailSalonInLavelleService = () => {
  return (
    <div className="hairSalonInLavelleService">
      <h3>
        Services Offered at SCENT Hair & Beauty Salon's Nail Salon in Lavelle
        Road
      </h3>
      <p>
        At our <a href="https://scentlifestyle.com/">nail salon in Lavelle Road</a>, we offer a variety of
        nail care services tailored to meet your specific needs. Here’s a
        glimpse of what we offer:
      </p>
      <li>
        <h6>Manicures:</h6>
        <p>
          From classic to contemporary, our{" "}
          <a href="https://scentlifestyle.com/salon-in-lavelle-road">nail salon in Lavelle Road</a> offers a range of manicures,
          including express, spa, gel, and French manicures. Each manicure is
          designed to keep your hands looking elegant and polished.
        </p>
      </li>
      <li>
        <h6> Pedicures:</h6>
        <p>
          Our pedicures at the nail salon in Lavelle Road are more than just
          beauty treatments; they are rejuvenating experiences. Choose from our
          classic, spa, or gel pedicures, each tailored to exfoliate, hydrate,
          and rejuvenate your feet.
        </p>
      </li>
      <li>
        <h6>Nail Extensions: </h6>
        <p>
          Want longer, more glamorous nails? The{" "}
          <a href="https://scentlifestyle.com/nails-salon">nail salon in Lavelle Road</a>
          offers high-quality nail extensions that are durable and stylish,
          perfect for those who want to make a statement.
        </p>
      </li>
      <li>
        <h6>Nail Art:</h6>
        <p>
          Express your unique style with our custom nail art designs. The nail
          salon in Lavelle Road has skilled artists who can create intricate
          patterns, trendy styles, and personalized designs to suit your mood
          and occasion.
        </p>
      </li>
      <li>
        <h6>Gel Polish:</h6>
        <p>
          Our nail salon in Lavelle Road offers a wide range of gel polish
          colors that are long-lasting, chip-resistant, and add a high-gloss
          finish to your nails.
        </p>
      </li>
      <li>
        <h6> Nail Treatments:</h6>
        <p>
          For clients seeking healthier nails, our nail salon in Lavelle Road
          provides specialized nail treatments, including strengthening and
          nourishing therapies to keep your nails strong and vibrant.
        </p>
      </li>
    </div>
  );
};

export default NailSalonInLavelleService;
